<template>
    <div class="py-3" v-if="selected_date">
        <b-row>
            <b-col cols="1" class="pr-2">
                <b-button b-button variant="primary" block @click="setDay('prev')">
                    <i class="fa fa-arrow-left" />
                </b-button>
            </b-col>
            <b-col cols="1" class="px-0">
                <b-button variant="primary" block @click="setDay()">
                    Today
                </b-button>
            </b-col>
            <b-col cols="1" class="pl-2">
                <b-button variant="primary" block @click="setDay('next')">
                    <i class="fa fa-arrow-right" />
                </b-button>
            </b-col>
            <b-col cols="4" class="px-0">
                <b-form-datepicker
                    v-model="selected_date"
                    :date-parser="(d) => { moment(d).format(date_format); }"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from "moment";

export default {
    name: "DatePicker",
    props: {
        date_format: {
            type: String,
            default: () => "YYYY-MM-DD",
        },
    },
    computed: {
      ...mapGetters(["selectedDate"]),
      selected_date: {
        get() {
          return this.selectedDate;
        },
        set(value) {
          this.onDayBtnClick({ date: moment(value) });
        },
      }
    },
    methods: {
      ...mapActions(["SET_SELECTED_DATE"]),
      onDayBtnClick({ date }) {
        this.SET_SELECTED_DATE(date.format(this.date_format));
      },
      setDay(dir) {
        switch (dir) {
          case "next":
            this.SET_SELECTED_DATE(
              moment(this.selected_date).add(1, "d").format(this.date_format)
            );
            break;
          case "prev":
            this.SET_SELECTED_DATE(
              moment(this.selected_date).subtract(1, "d").format(this.date_format)
            );
            break;
          default:
            this.SET_SELECTED_DATE(moment().format(this.date_format));
        }
      },
    },
    watch: {
        selected_date: {
            handler() {
                this.$emit("date_change", this.selected_date)
            },
            immediate: true,
        }
    }
}
</script>